// Third-party Imports
import { GeistMono } from 'geist/font/mono'
import { GeistPixelSquare } from 'geist/font/pixel'

// Brand Imports
import { fontBody, fontHeading } from '@/utils/brand-fonts'

/**
 * Сайтын фонтууд.
 *
 * Гарчиг, бичвэр хоёулаа Google Sans — public/fonts дотор
 * өөрсдөө байршуулсан. Google Fonts-оос татдаг байсныг больсон:
 * гадны сүлжээнээс хамаарахгүй бөгөөд build нь fonts.gstatic.com
 * унасан ч зогсохгүй.
 */

export { fontHeading, fontBody }
export { GeistMono as fontGeistMono, GeistPixelSquare as fontGeistPixelSquare }

// All font instances – spread as className on <html> in layout.tsx to register CSS variables
export const allFonts = [fontHeading, fontBody, GeistMono, GeistPixelSquare]

export type FontGroup = 'sans' | 'mono' | 'serif'

// Font selector config – label, CSS variable, and group for each font
export const FONT_CONFIG = {
  'brand-body': { label: 'Google Sans', variable: '--font-brand-body', group: 'sans' as FontGroup },
  'brand-heading': { label: 'Google Sans', variable: '--font-brand-heading', group: 'sans' as FontGroup },
  'geist-mono': { label: 'Geist Mono', variable: '--font-geist-mono', group: 'mono' as FontGroup },
  'geist-pixel': { label: 'Geist Pixel', variable: '--font-geist-pixel-square', group: 'mono' as FontGroup }
} as const

// Ordered group labels for rendering
export const FONT_GROUPS: { key: FontGroup; label: string }[] = [
  { key: 'sans', label: 'Sans' },
  { key: 'mono', label: 'Mono' },
  { key: 'serif', label: 'Serif' }
]

export type FontKey = keyof typeof FONT_CONFIG
